export default __webpack_public_path__ + "static/media/hero_img.c267e67c.png";